
export default function Locations() {
    // @ts-ignore
    const logoStyle = { "display": "block", "maxWidth":"60%", "margin":"auto" } as React.CSSProperties;
    return (
        <div className="bg-gray-50">

            <div className="max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:py-6 lg:px-8">

                <div className="divide-y-2 divide-gray-200">
                    <div className="lg:grid lg:grid-cols-3 lg:gap-8">
                        {/*<h2 className="text-2xl font-extrabold text-gray-900 sm:text-3xl">Get in touch</h2>*/}
                        {/*<div className="mt-8 grid grid-cols-1 gap-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:mt-0 lg:col-span-2">*/}
                        {/*    <div>*/}
                        {/*        <h3 className="text-lg leading-6 font-medium text-gray-900">Collaborate</h3>*/}
                        {/*        <dl className="mt-2 text-base text-gray-500">*/}
                        {/*            <div>*/}
                        {/*                <dt className="sr-only">Email</dt>*/}
                        {/*                <dd>hello@358.ee</dd>*/}
                        {/*            </div>*/}
                        {/*            /!*<div className="mt-1">*!/*/}
                        {/*            /!*    <dt className="sr-only">Phone number</dt>*!/*/}
                        {/*            /!*    <dd>+1 (555) 123-4567</dd>*!/*/}
                        {/*            /!*</div>*!/*/}
                        {/*        </dl>*/}
                        {/*    </div>*/}
                        {/*    <div>*/}
                        {/*        <h3 className="text-lg leading-6 font-medium text-gray-900">Privacy</h3>*/}
                        {/*        <dl className="mt-2 text-base text-gray-500">*/}
                        {/*            <div>*/}
                        {/*                <dt className="sr-only">Email</dt>*/}
                        {/*                <dd>privacy@358.ee</dd>*/}
                        {/*            </div>*/}
                        {/*            /!*<div className="mt-1">*!/*/}
                        {/*            /!*    <dt className="sr-only">Phone number</dt>*!/*/}
                        {/*            /!*    <dd>+1 (555) 123-4567</dd>*!/*/}
                        {/*            /!*</div>*!/*/}
                        {/*        </dl>*/}
                        {/*    </div>*/}
                            {/*<div>*/}
                            {/*    <h3 className="text-lg leading-6 font-medium text-gray-900">Join our team</h3>*/}
                            {/*    <dl className="mt-2 text-base text-gray-500">*/}
                            {/*        <div>*/}
                            {/*            <dt className="sr-only">Email</dt>*/}
                            {/*            <dd>support@example.com</dd>*/}
                            {/*        </div>*/}
                            {/*        <div className="mt-1">*/}
                            {/*            <dt className="sr-only">Phone number</dt>*/}
                            {/*            <dd>+1 (555) 123-4567</dd>*/}
                            {/*        </div>*/}
                            {/*    </dl>*/}
                            {/*</div>*/}
                            {/*<div>*/}
                            {/*    <h3 className="text-lg leading-6 font-medium text-gray-900">Say hello</h3>*/}
                            {/*    <dl className="mt-2 text-base text-gray-500">*/}
                            {/*        <div>*/}
                            {/*            <dt className="sr-only">Email</dt>*/}
                            {/*            <dd>support@example.com</dd>*/}
                            {/*        </div>*/}
                            {/*        <div className="mt-1">*/}
                            {/*            <dt className="sr-only">Phone number</dt>*/}
                            {/*            <dd>+1 (555) 123-4567</dd>*/}
                            {/*        </div>*/}
                            {/*    </dl>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    </div>
                    <div className="mt-16 pt-16 lg:grid lg:grid-cols-3 lg:gap-8">
                        <h2 className="text-2xl font-extrabold text-gray-900 sm:text-3xl">Locations</h2>
                        <div className="mt-8 grid grid-cols-1 gap-12 sm:grid-cols-2 sm:gap-x-8 sm:gap-y-12 lg:mt-0 lg:col-span-2">
                            <div>
                                <h3 className="text-lg leading-6 font-medium text-gray-900">Tallinn</h3>
                                <div className="mt-2 text-base text-gray-500">
                                    <p>Tammsaare Business Center</p>
                                    <p className="mt-1">A. H. Tammsaare tee 47</p>
                                    <p className="mt-1">Tallinn, 11316</p>
                                    <p className="mt-1">Harju maakond</p>
                                    <p className="mt-1">Estonia</p>
                                    <p className="mt-1">hello@358.ee</p>
                                </div>
                            </div>
                            <div>
                                {/*<h3 className="text-lg leading-6 font-medium text-gray-900">New York</h3>*/}
                                <div className="text-base text-center object-center">
                                    <img alt="" src="/logo_full.svg" style={logoStyle} className="object-center align-middle" />
                                </div>
                            </div>
                            {/*<div>*/}
                            {/*    <h3 className="text-lg leading-6 font-medium text-gray-900">Toronto</h3>*/}
                            {/*    <div className="mt-2 text-base text-gray-500">*/}
                            {/*        <p>7363 Cynthia Pass</p>*/}
                            {/*        <p className="mt-1">Toronto, ON N3Y 4H8</p>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*<div>*/}
                            {/*    <h3 className="text-lg leading-6 font-medium text-gray-900">Chicago</h3>*/}
                            {/*    <div className="mt-2 text-base text-gray-500">*/}
                            {/*        <p>726 Mavis Island</p>*/}
                            {/*        <p className="mt-1">Chicago, IL 60601</p>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
